export const TypeEnum = {
  OpenOrders: 'OpenOrders',
  OpenReceipts: 'OpenReceipts',
  OpenReceiptsKO: 'OpenReceiptsKO',
};
export const ColumnHeaders = {
  WO: 'WO #',
  KO: 'KO #',
  Order: 'Order #',
  Remove_Qty: 'Remove Qty',
  Add_Qty: 'Add Qty',
};

export const TypeOptionEnum = {
  ItemToAdd: 0,
  ItemToRemove: 1,
  Both: 2,
};
export const UpdateOpenOrderTypeEnum = {
  Order: 0,
  Receipt: 1,
};

export const InitialValuesEnum = {
  SiteGroup: 0,
  WarehouseKitchen: '0',
  AddItemListData: 0,
  RemoveItemListData: 0,
  Kitchen: '0',
};

export const OrderTypeEnum = {
  OpenOrder: 0,
  OpenReceiptWO: 1,
  OpenReceiptKO: 2,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/UpdateOpenOrderEnum.js